export const DASHBOARD = "report/DASHBOARD";
export const DASHBOARD_COMPLETED = "report/DASHBOARD_COMPLETED";
export const DASHBOARD_FAILED = "report/DASHBOARD_FAILED";

